// https://github.com/HatScripts/circle-flags
// https://www.icon.org/obp/ui/#search/code/
export default [
  { value: 13, name: 'Australia', icon: 'au.svg' },
  { value: 64, name: 'Canada', icon: 'ca.svg' },
  { value: 121, name: 'USA', icon: 'us.svg' },
];
